import { PureQueryOptions } from 'apollo-client';
import gql from 'graphql-tag';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ViewerContext } from '../../types/viewer_context';

@Component({ components: {} })
export default class CommentsList extends Vue {
  @Prop() public comments!: any[];
  @Prop() public suggestionsListId!: string;
  @Prop() public refetch!: PureQueryOptions;
  @Getter public loginInformation: any;
  @Getter public viewerContext!: ViewerContext;

  public commentContent: string = '';
  public feedbackContent: string = '';

  public mounted() {
    console.log('mounted');
  }

  // display a feedback type of box if its a library, and the library has
  // not written any comment yet.x
  public shouldDisplayFeedback(): boolean {
    return (
      this.viewerContext.institutionType == 'LIBRARY' &&
      this.comments.findIndex(
        (comment) => comment.userInstitution == 'LIBRARY'
      ) == -1
    );
  }

  @Emit('add-comment')
  public async addComment(text: null): Promise<void> {
    const loader = this.$loading.show();
    try {
      await this.$apollo.mutate({
        mutation: gql`
          mutation(
            $suggestionsListId: ID!
            $user: String!
            $content: String!
            $userInstitution: InstitutionType!
          ) {
            addComment(
              input: {
                suggestionsListId: $suggestionsListId
                user: $user
                content: $content
                userInstitution: $userInstitution
              }
            )
          }
        `,
        refetchQueries: [this.refetch],
        variables: {
          content: text,
          user: this.loginInformation.displayName,
          suggestionsListId: this.suggestionsListId,
          userInstitution: this.viewerContext.institutionType,
        },
      });
    } finally {
      loader.hide();
      this.commentContent = '';
    }
  }
}
